import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const BadgeLabelHeading = ({
  text = 'Heading',
  fontSize = '14px',
  fontWeight = 500,
  disabled = false,
  mb = 2,
  sx = {},
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const labelBackground = isDark
    ? '#660000'
    : 'linear-gradient(135deg, #2196f3, #21cbf3)';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        mb: mb,
        ...sx,
      }}
    >
      <Typography
        component="span"
        sx={{
          background: disabled ? '#cccccc' : labelBackground,
          color: disabled ? '#333333' : '#fff',
          fontWeight: fontWeight,
          clipPath: 'polygon(0% 0%, 100% 0%, 95% 100%, 5% 100%)',
          padding: '4px 14px',
          borderRadius: 0,
          fontSize: fontSize,
          lineHeight: 1,
          display: 'inline-block',
          userSelect: 'none',
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default BadgeLabelHeading;



